// Dark Mode Color Foundation
// Not fully implemented yet

export default {
   // GLobal
   globalNavLogoFieldName: 'logoDefaultNegative',
   tmpBackgroundColor: '#000',
   tmpBodyTextColor: '#777',
   tmpFooterBackgroundColor: '#111',
   // Aside
   tmpAsideBodyTextColor: 'rgba(255,255,255,0.4)',
   tmpAsideButtonTextColor: '#666',
   tmpAsideButtonActiveTextColor: '#fff',
   tmpAsideButtonActiveBackgroundColor: '#111',
   tmpAsideLineColor: '#111',
   tmpAsideTitleColor: '#fff',
   // Content
   tmpContentBackgroundColor: '#080808',
   tmpContentLineColor: '#111',
   tmpContentTitleColor: '#fff',
   // Main Menu
   tmpMainMenuLineColor: '#080808',
   tmpMainMenuBackgroundColor: '#000',
   tmpMainMenuBorderColor: '#040404',
   tmpMainMenuButtonTextColor: '#666',
   tmpMainMenuButtonActiveTextColor: '#fff',
   tmpMainMenuButtonActiveBackgroundColor: '#111',
   tmpMainMenuSearchBackgroundColor: 'rgba(255,255,255,0.07)',
   tmpMainMenuTextColor: '#666',
   tmpMainMenuTitleColor: '#fff',
   // Will change
   tmpBorderColor: '#111',
   tmpColumnBorderColor: '#111'
}
